import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import "../../../Styles/pages/bill-service.scss";
import { isDisplayableAutomatedBillValue } from "./automatedBillsUtils";

export default function ProviderHeader({
  provider,
  onBack,
  backLabel = "Back to Bills",
}) {
  const hasImage = isDisplayableAutomatedBillValue(provider?.image);
  const hasDescription = isDisplayableAutomatedBillValue(provider?.description);

  return (
    <div className="bill-service-page__stack">
      <button
        type="button"
        className="bill-service-page__back btn"
        onClick={onBack}
      >
        <FontAwesomeIcon icon={faArrowLeftLong} />
        <span>{backLabel}</span>
      </button>

      <section className="bill-details-card card">
        <div className="bill-details-card__brand">
          {hasImage ? (
            <div className="bill-details-card__logo">
              <img src={provider.image} alt={provider?.title || "Provider"} />
            </div>
          ) : null}
          <div className="bill-details-card__copy">
            <h2>{provider?.title || "Bill Service"}</h2>
            {hasDescription ? <p>{provider.description}</p> : null}
          </div>
        </div>
      </section>
    </div>
  );
}
